import { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export function CertificationNumberLabel({
  label,
  textColorClassName,
  textColorHoverClassName,
  className,
  isHover,
}) {
  const classes = [
    isHover === false && textColorClassName,
    isHover === true && textColorHoverClassName,
    className,
  ];

  return (
    <div className={clsx('whitespace-nowrap font-sans transition ease-in-out duration-150', classes)}>
      {label}
    </div>
  );
}

CertificationNumberLabel.defaultProps = {
  textColorClassName: 'text-gray-500',
  textColorHoverClassName: 'text-green-600',
  className: 'font-normal',
  isHover: false,
};

CertificationNumberLabel.propTypes = {
  label: PropTypes.node.isRequired,
  textColorClassName: PropTypes.string,
  textColorHoverClassName: PropTypes.string,
  className: PropTypes.string,
  isHover: PropTypes.bool,
};

export function CertificationNumberValue({
  value,
  isHover,
}) {
  const classes = [
    isHover === true && 'text-gray-900',
    isHover === false && 'text-green-600',
  ];

  return (
    <p className={clsx('mb-0 font-medium text-base transition ease-in-out duration-150 font-mono', classes)}>
      {value}
    </p>
  );
}

CertificationNumberValue.defaultProps = {
  isHover: false,
};

CertificationNumberValue.propTypes = {
  value: PropTypes.node.isRequired,
  isHover: PropTypes.bool,
};


export function CertificationNumberDivider({
  isHover,
}) {
  const classes = [
    isHover === true && 'border-gray-300',
    isHover === false && 'border-gray-200',
  ];

  return (
    <div className={clsx('flex-1 border-b-2 border-dashed transition ease-in-out duration-150', classes)} />
  );
}

CertificationNumberDivider.defaultProps = {
  isHover: false,
};

CertificationNumberDivider.propTypes = {
  isHover: PropTypes.bool,
};

const defaultProps = {};

const propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

export default function CertificationNumber({
  label,
  value,
}) {
  const [isHover, setHover] = useState(false);

  return (
    <div
      className="flex items-center w-full space-x-4 cursor-pointer focus:outline-none"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      tabIndex="-1"
    >
      <CertificationNumberLabel label={label} isHover={isHover} />
      <CertificationNumberDivider isHover={isHover} />
      <CertificationNumberValue value={value} isHover={isHover} />
    </div>
  );
}

CertificationNumber.defaultProps = defaultProps;
CertificationNumber.propTypes = propTypes;
